export default function({ $auth, redirect, store }) {
 	if ($auth.$state.loggedIn === true)
 		redirect(302, store.IsMobile ? '/mobile' : '/')
}